import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import colors from '../../../../scss/colors';

export default function WithCloseIcon(props) {
  const {
    icon = (
      <CloseIcon
        sx={{
          color: colors.ICON_GREY,
          fontSize: '34px',
          '&:hover': {
            color: colors.DARKEST_GREY
          }
        }}
      />
    ),
    position = 'top-right',
    x = 0,
    y = 0,
    close,
    children,
    sx
  } = props;

  // You can add your own customised options if it`s necessary
  const positions = {
    'top-left': { top: `${y}px`, left: `${x}px` },
    'top-right': { top: `${y}px`, right: `${x}px` },
    'bottom-left': { bottom: `${y}px`, left: `${x}px` },
    'bottom-right': { bottom: `${y}px`, right: `${x}px` }
  };

  return (
    <div style={{ position: 'relative' }}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div style={{ position: 'absolute', ...positions[position], cursor: 'pointer', ...sx }} onClick={close}>
        {icon}
      </div>
      {children}
    </div>
  );
}
